import VolumeOff from '../../src/legacy/VolumeOff';
export default VolumeOff;
